import { getConfig } from '@local/app-config';
import { trace } from '@opentelemetry/api';
import { logs } from '@opentelemetry/api-logs';
import { ZoneContextManager } from '@opentelemetry/context-zone';
import { W3CTraceContextPropagator } from '@opentelemetry/core';
import { OTLPLogExporter } from '@opentelemetry/exporter-logs-otlp-http';
import { OTLPTraceExporter } from '@opentelemetry/exporter-trace-otlp-http';
import { registerInstrumentations } from '@opentelemetry/instrumentation';
import { FetchInstrumentation } from '@opentelemetry/instrumentation-fetch';
import { XMLHttpRequestInstrumentation } from '@opentelemetry/instrumentation-xml-http-request';
import { Resource } from '@opentelemetry/resources';
import { BatchLogRecordProcessor, LoggerProvider, SimpleLogRecordProcessor, ConsoleLogRecordExporter, } from '@opentelemetry/sdk-logs';
import { WebTracerProvider, SimpleSpanProcessor, ConsoleSpanExporter, } from '@opentelemetry/sdk-trace-web';
import { SEMRESATTRS_DEPLOYMENT_ENVIRONMENT, SEMRESATTRS_SERVICE_NAME, SEMRESATTRS_SERVICE_VERSION, } from '@opentelemetry/semantic-conventions';
import { ATTRIBUTE_SESSION_ID, UNKNOWN } from './metrics.constants';
export default function TraceProvider({ children, openTelemetryConfig, }) {
    var _a, _b, _c, _d, _e, _f, _g, _h;
    const isProduction = ((_b = (_a = getConfig()) === null || _a === void 0 ? void 0 : _a.environment) !== null && _b !== void 0 ? _b : 'production') === 'production';
    const { name, version } = openTelemetryConfig;
    const hasConsole = (_c = openTelemetryConfig === null || openTelemetryConfig === void 0 ? void 0 : openTelemetryConfig.withConsoleExporter) !== null && _c !== void 0 ? _c : false;
    const sessionId = (_e = (_d = window === null || window === void 0 ? void 0 : window.crypto) === null || _d === void 0 ? void 0 : _d.randomUUID()) !== null && _e !== void 0 ? _e : 'no-crypto';
    const exporterConfig = Object.assign({ headers: {
            'Content-Type': 'application/json',
            Authorization: `Basic ${(_f = openTelemetryConfig === null || openTelemetryConfig === void 0 ? void 0 : openTelemetryConfig.auth) !== null && _f !== void 0 ? _f : 'c2VlcXVlbnRfb3RlbF9leHRlcm5hbF93ZWJhcHBzOmk0bld0dXlVenpqWTkxV0c4dVF0ZHQ0MWtQdERTbmpLYw=='}`,
        }, url: 'https://otel.elastic.seequent.com/v1/traces' }, openTelemetryConfig === null || openTelemetryConfig === void 0 ? void 0 : openTelemetryConfig.exporterConfig);
    const resource = new Resource(Object.assign({ [SEMRESATTRS_SERVICE_NAME]: name, [SEMRESATTRS_SERVICE_VERSION]: version, [ATTRIBUTE_SESSION_ID]: sessionId, [SEMRESATTRS_DEPLOYMENT_ENVIRONMENT]: (_h = (_g = getConfig()) === null || _g === void 0 ? void 0 : _g.environment) !== null && _h !== void 0 ? _h : UNKNOWN }, openTelemetryConfig === null || openTelemetryConfig === void 0 ? void 0 : openTelemetryConfig.resourceAttributes));
    const provider = new WebTracerProvider({ resource });
    const instruments = [];
    const fetchInstrumentation = (openTelemetryConfig === null || openTelemetryConfig === void 0 ? void 0 : openTelemetryConfig.fetchConfig)
        ? new FetchInstrumentation(Object.assign({}, openTelemetryConfig === null || openTelemetryConfig === void 0 ? void 0 : openTelemetryConfig.fetchConfig))
        : undefined;
    if (fetchInstrumentation) {
        fetchInstrumentation.setTracerProvider(provider);
        instruments.push(fetchInstrumentation);
    }
    const xhrInstrumentation = (openTelemetryConfig === null || openTelemetryConfig === void 0 ? void 0 : openTelemetryConfig.xhrConfig)
        ? new XMLHttpRequestInstrumentation(Object.assign({}, openTelemetryConfig === null || openTelemetryConfig === void 0 ? void 0 : openTelemetryConfig.xhrConfig))
        : undefined;
    if (xhrInstrumentation) {
        xhrInstrumentation.setTracerProvider(provider);
        instruments.push(xhrInstrumentation);
    }
    const traceExporter = new OTLPTraceExporter(exporterConfig);
    provider.addSpanProcessor(new SimpleSpanProcessor(traceExporter));
    const logExporter = new OTLPLogExporter(Object.assign(Object.assign({}, exporterConfig), { url: 'https://otel.elastic.seequent.com/v1/logs' }));
    const loggerProvider = new LoggerProvider({ resource });
    loggerProvider.addLogRecordProcessor(new BatchLogRecordProcessor(logExporter));
    if (hasConsole && !isProduction) {
        const consoleExporter = new ConsoleSpanExporter();
        provider.addSpanProcessor(new SimpleSpanProcessor(consoleExporter));
        loggerProvider.addLogRecordProcessor(new SimpleLogRecordProcessor(new ConsoleLogRecordExporter()));
    }
    const zoneManager = new ZoneContextManager();
    const propagator = new W3CTraceContextPropagator();
    provider.register({
        contextManager: zoneManager.enable(),
        propagator,
    });
    registerInstrumentations({
        instrumentations: instruments,
        tracerProvider: provider,
    });
    logs.setGlobalLoggerProvider(loggerProvider);
    trace.setGlobalTracerProvider(provider);
    if (!(window === null || window === void 0 ? void 0 : window.otelTracer) && provider) {
        window.otelTracer = provider;
    }
    return children;
}
//# sourceMappingURL=TraceProvider.js.map